
import {Vue, Component, Prop} from 'vue-property-decorator'

import PaymentMode from '@/shared/enums/PaymentMode'
import EButton from '../Button.vue'
import EFooter from '../Footer.vue'

@Component({
  components: {
    EButton,
    EFooter,
  },
})
export default class MobileLayout extends Vue {
  @Prop({required: true})
  paymentMethod!: PaymentMode | null

  changePaymentMethod() {
    this.$emit('changePaymentMethod', null)
  }
}
